import { SINGLE_NUMERIC, SINGLE_STRING } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const s: EffectEntry = {
  kind: 's',
  category: 'effect',
  family: 'sample',
  doc: 'set waveform on note() voices: "sawtooth", "square", "supersaw", "sine"',
  args: SINGLE_STRING,
  toCode: () => STUB_NOT_IMPLEMENTED('s', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('s', 'fromAst'),
};

export const n: EffectEntry = {
  kind: 'n',
  category: 'effect',
  family: 'sample',
  doc: 'sample bank index, e.g. n(2) selects the 3rd sample in the bank',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('n', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('n', 'fromAst'),
};

export const orbit: EffectEntry = {
  kind: 'orbit',
  category: 'effect',
  family: 'sample',
  doc: 'audio bus id (0–11) — same orbit shares reverb/delay sends',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('orbit', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('orbit', 'fromAst'),
};

export const octave: EffectEntry = {
  kind: 'octave',
  category: 'effect',
  family: 'sample',
  doc: 'shift all notes by N octaves',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('octave', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('octave', 'fromAst'),
};

export const cut: EffectEntry = {
  kind: 'cut',
  category: 'effect',
  family: 'sample',
  doc: 'cut group — events in the same group choke each other',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('cut', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('cut', 'fromAst'),
};

export const begin: EffectEntry = {
  kind: 'begin',
  category: 'effect',
  family: 'sample',
  doc: 'start offset into the sample (0 = head, 0.5 = midway)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('begin', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('begin', 'fromAst'),
};

export const end: EffectEntry = {
  kind: 'end',
  category: 'effect',
  family: 'sample',
  doc: 'end offset (1 = full, 0.25 = first quarter)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('end', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('end', 'fromAst'),
};

export const loop: EffectEntry = {
  kind: 'loop',
  category: 'effect',
  family: 'sample',
  doc: 'loop the sample (1 = on)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('loop', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('loop', 'fromAst'),
};

export const loopBegin: EffectEntry = {
  kind: 'loopBegin',
  category: 'effect',
  family: 'sample',
  doc: 'loop start fraction',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('loopBegin', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('loopBegin', 'fromAst'),
};

export const loopEnd: EffectEntry = {
  kind: 'loopEnd',
  category: 'effect',
  family: 'sample',
  doc: 'loop end fraction',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('loopEnd', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('loopEnd', 'fromAst'),
};

export const loopFirst: EffectEntry = {
  kind: 'loopFirst',
  category: 'effect',
  family: 'sample',
  doc: 'alternate form of loopBegin',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('loopFirst', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('loopFirst', 'fromAst'),
};

export const chop: EffectEntry = {
  kind: 'chop',
  category: 'effect',
  family: 'sample',
  doc: 'chop the sample into N equal slices played in sequence',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('chop', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('chop', 'fromAst'),
};

export const striate: EffectEntry = {
  kind: 'striate',
  category: 'effect',
  family: 'sample',
  doc: 'like chop but interleaves slices across events',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('striate', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('striate', 'fromAst'),
};

export const striateBy: EffectEntry = {
  kind: 'striateBy',
  category: 'effect',
  family: 'sample',
  doc: 'striate with an explicit size',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('striateBy', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('striateBy', 'fromAst'),
};

export const fit: EffectEntry = {
  kind: 'fit',
  category: 'effect',
  family: 'sample',
  doc: 'fit a sample into N beats',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('fit', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('fit', 'fromAst'),
};

export const fitslice: EffectEntry = {
  kind: 'fitslice',
  category: 'effect',
  family: 'sample',
  doc: 'fit + slice: re-slice to match the pattern',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('fitslice', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('fitslice', 'fromAst'),
};

export const slice: EffectEntry = {
  kind: 'slice',
  category: 'effect',
  family: 'sample',
  doc: 'select slice indices from a chopped sample',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('slice', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('slice', 'fromAst'),
};
